import { render } from "./IdPager.vue?vue&type=template&id=ae7e721a"
import script from "./IdPager.vue?vue&type=script&lang=js"
export * from "./IdPager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__